let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("goR8B")).then(() => parcelRequire('1rGkg'));